export default () => ({
  requirementSpecifications: []
})
